<template>
  <div class="columns">
    <div class="column">

      <b-message v-if="threads.length === 1 && $store.getters.activeThreadUntouched" type="is-info" has-icon>
        <h1 class="is-size-4">You currently have no saved tweets or threads.</h1>
        <div class="content">
          <ul>
            <li>Drafts will be automatically save here as you type.</li>
            <li>Drafts are saved locally to your browser, not in the cloud. They are also not tied to a specific Twitter account until you publish or schedule it.</li>
            <li>New drafts can be created by clicking "add new draft" on the <router-link to="/app/" class="has-text-link">Compose</router-link> page.</li>
          </ul>
        </div>
      </b-message>

      <div v-else v-for="thread in threads" :key="thread.index">
        <div class="box is-flex mb-2 is-clickable is-align-items-center" @click.prevent="switchThread(thread)">
          <div class="p-2 is-flex-grow-1" style="width: 60%">
            <h3 class="is-size-5">
              <span v-if="thread.title.trim()">{{ thread.title.trim() }}</span>
              <span v-else>Untitled thread</span>
              <a href="#" @click.stop="setTitle(thread)">
                <b-icon icon="pencil-alt" class="is-clickable" size="is-size-6 ml-2"/>
              </a>
            </h3>
            <p class="draft-text"><em>{{ thread.tweets[0].text }}</em></p>
          </div>
          <div class="p-2 has-text-centered" style="width: 10%">
            <p class="heading">Tweets</p>
            <p class="title">{{ thread.tweets.length }}</p>
          </div>
          <div class="p-2 has-text-centered" style="width: 30%;">
            <p class="heading">Last Edit</p>
            <p class="title is-size-4">
              {{ thread.last_edit !== undefined ? formatDistanceToNow(thread.last_edit) + ' ago' : '-' }}</p>
          </div>
          <div class="p-2 has-text-centered">
            <a href="#" @click.stop="deleteThread(thread)">
              <b-icon icon="times-circle" type="is-danger" size="is-large"></b-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {formatDistanceToNow} from "date-fns"

export default {
  name: "Drafts",
  computed: {
    threads() {
      return this.$store.getters.threadsByLastEdit
    }
  },
  methods: {
    formatDistanceToNow: formatDistanceToNow,
    switchThread(thread) {
      this.$store.dispatch('switchActiveThread', thread.index)
      this.$router.push('/app/compose')
    },
    setTitle(thread) {
      this.$buefy.dialog.prompt({
        message: '<strong>Enter your own thread title.</strong> This is never published to Twitter or made public, it is just a name for your own future reference.',
        scroll: 'keep',
        trapFocus: true,
        inputAttrs: {
          value: thread.title,
          required: false,
        },
        onConfirm: (value) => {
          this.$store.commit('setThreadTitle', {index: thread.index, text: value})
        }
      })
    },
    deleteThread(thread) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to delete this thread?',
        scroll: 'keep',
        onConfirm: () => {
          this.$store.dispatch('removeThread', thread.index)
          this.$buefy.snackbar.open({
            message: 'Thread deleted',
            position: 'is-top',
            actionText: "OK",
            duration: 3000,
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.draft-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.box > div {
  min-width: 10rem;
}

</style>
